import { render, staticRenderFns } from "./categoryEdit.vue?vue&type=template&id=c242cae6"
import script from "./categoryEdit.vue?vue&type=script&lang=js"
export * from "./categoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports